// extracted by mini-css-extract-plugin
module.exports = {"container":"form-input_container__NcNay","label":"form-input_label__13uS2","error":"form-input_error__qAmGe","borderErr":"form-input_borderErr__2Yt_Y"};